import { Container } from "react-bootstrap";

import MB from "../images/coaches-profile-pics/markb.png";
import RC from "../images/coaches-profile-pics/raulc.png";
import GJ from "../images/coaches-profile-pics/glynj.png";
import MG from "../images/coaches-profile-pics/mattg.png";
import BD from "../images/coaches-profile-pics/billyd.png";
import ROM from "../images/coaches-profile-pics/rom.png";
import AMIE from "../images/coaches-profile-pics/amie.png";

function Coaches() {
  return (
    <>
      <Container className="hero-img-container">
        <div
          className="hero-image coaches-hero-image"
          aria-label="Group picture of the New Era Boxing coaching team"
        >
          <div className="main-container">
            <div className="content-container">
              <div className="hero-sub-images">
                <div className="hero-text hero-text-padding">
                  <h1 className="hero-text-padding">
                    OUR COACHES & VOLUNTEERS
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="padding-spacing"></div>

        {/* <div class="card" style={{ width: "18rem" }}>
          <img class="card-img-top" src={MB} alt="Card image cap" />
          <div class="card-body">
            <h4 class="card-title">MARK BEBBINGTON</h4>
            <p className="card-text">LEAD BOXING COACH</p>
            <p class="card-text">
              - Level 3 Senior England Boxing Coach
            </p>
            <p class="card-text">
              - England Boxing Coach Educator
            </p>
            <p class="card-text">
              - Diploma in Sports & Exercise Nutrition
            </p>
          </div>
        </div> */}

        <div className="card flex-row">
          <div className="card-header border-0">
            <img
              src={MB}
              alt="Profile picture of lead boxing coach Mark Bebbington"
              className="coach-profile-pic"
            />
          </div>
          <div className="card-block px-2">
            <h3 className="card-title">MARK BEBBINGTON</h3>
            <h4 className="card-text">LEAD BOXING COACH</h4>
            <h5>
              Level 3 Senior England Boxing Coach | England Boxing Coach
              Educator | Diploma in Sports & Exercise Nutrition.
            </h5>
            <p>
              "I established New Era Community Boxing in 2011 with a focus on
              high performance coaching whilst maintaining a community club
              ethos.
            </p>
            <p>
              My main focus is to allow every member, competitor and coach to
              express themselves whilst at the club, progress and improve both
              their physical and technical skills. It is my ambition to promote
              the club both locally and nationally in a positive light and give
              its members the best opportunity to succeed."
            </p>
          </div>
        </div>
        <div className="padding-spacing"></div>

        <div className="card flex-row">
          <div className="card-header border-0">
            <img
              src={RC}
              alt="Profile picture of level 1 boxing coach Raul Comorasu"
              className="coach-profile-pic"
            />
          </div>
          <div className="card-block px-2">
            <h3 className="card-title">RAUL COMORASU</h3>
            <h4 className="card-text">LEVEL 2 ENGLAND BOXING COACH</h4>
            <p>
              As a level 1 boxing coach, my specialities include knowledge on
              how to help produce competitors and work on specific pointers to
              bring out the best in peoples abilities.
            </p>
            <p>
              As a coach my experience in the sport includes acting as a corner
              man for amateur boxer on many occassions, either acting as lead
              coach or as coaching assistant. I run personalised training
              sessions for all ages from young children to elderly adults.
            </p>
            <p>
              I also still box competitively and have performed in 41
              competitive bouts which allows me to approach training with a
              boxers perspective.
            </p>
          </div>
        </div>
        <div className="padding-spacing"></div>

        <div className="card flex-row">
          <div className="card-header border-0">
            <img
              src={GJ}
              alt="Profile picture of level 2 boxing coach Glyn Jones"
              className="coach-profile-pic"
            />
          </div>
          <div className="card-block px-2">
            <h3 className="card-title">GLYN JONES</h3>
            <h4 className="card-text">LEVEL 2 ENGLAND BOXING COACH</h4>
            <p>
              I have been involved in boxing for over 30 years and certified as
              a level 2 England boxing coach.
            </p>
            <p>
              I introduced to boxing at Weaverham ABC while I was at school, and
              gained further experience from many other gyms within the area. I
              have been involved in many forms of martial arts and also competed
              in kickboxing at high level of competition.
            </p>
            <p>
              Since Mark opened New Era Boxing I have been assisting with
              training sessions and have acted as corner man for many of the
              clubs competitors.
            </p>
          </div>
        </div>
        <div className="padding-spacing"></div>

        <div className="card flex-row">
          <div className="card-header border-0">
            <img
              src={MG}
              alt="Profile picture of level 1 boxing coach Matthew Griffiths"
              className="coach-profile-pic"
            />
          </div>
          <div className="card-block px-2">
            <h3 className="card-title">MATTHEW GRIFFITHS</h3>
            <h4 className="card-text">
              LEVEL 1 ENGLAND BOXING COACH | SAFEGUARDING LEAD
            </h4>
            <p>
              I joined New Era Boxing in 2013 and I have competed for the club
              in multiple bouts.
            </p>
            <p>
              Since joining the club, I have become a qualified level 1 England
              boxing coach. I often lead training sessions for both casual and
              competive members, with a focus on strenght and conditioning.
            </p>
          </div>
        </div>
        <div className="padding-spacing"></div>

        <div className="card flex-row">
          <div className="card-header border-0">
            <img
              src={BD}
              alt="Profile picture of level 2 fitness instructor and volunteer Billy Dotchin"
              className="coach-profile-pic"
            />
          </div>
          <div className="card-block px-2">
            <h3 className="card-title">BILLY DOTCHIN</h3>
            <h4 className="card-text">
              LEVEL 2 FITNESS INSTRUCTOR | VOLUNTEER
            </h4>
            <p>
              I joined New Era Boxing when I was 10 years old. Since joining the
              club I have gained lots of experience and have represented New Era
              in multiple competitions.
            </p>
            <p>
              I have acquired my level 2 fitness instructor qualification and
              working towards my level 3 personal training qualification. I
              often volunteer to help out with training sessions at the club and
              provide personla 121 sessions for people of all abilities.
            </p>
          </div>
        </div>
        <div className="padding-spacing"></div>

        <div className="card flex-row">
          <div className="card-header border-0">
            <img
              src={AMIE}
              alt="Profile picture of club volunteer Amie"
              className="coach-profile-pic"
            />
          </div>
          <div className="card-block px-2">
            <h3 className="card-title">AMIE BAGNALL</h3>
            <h4 className="card-text">
              QUALIFIED PRIMARY TEACHER | CHILDHOOD STUDIES DEGREE |
              POSTGRADUATE CERTIFICATE IN EDUCATION | VOLUNTEER
            </h4>
            <p>
              My background as a teacher and an experienced runner has allowed
              me to volunteer at New Era Boxing in a number of ways, including
              assisting with training sessions and providing club members with
              running plans.
            </p>
            <p>
              I also assist the club with administrative tasks and help
              coordinate events.
            </p>
          </div>
        </div>
        <div className="padding-spacing"></div>

        <div className="card flex-row">
          <div className="card-header border-0">
            <img
              src={ROM}
              alt="Profile picture of club volunteer Romilly"
              className="coach-profile-pic"
            />
          </div>
          <div className="card-block px-2">
            <h3 className="card-title">ROMILLY SORENSON</h3>
            <h4 className="card-text">STUDENT MEMBER | VOLUNTEER</h4>
            <p>
              Romilly is a student member of New Era Boxing who has volunteered
              to help out with various tasks around the club, including
              assisting with training sessions.
            </p>
          </div>
        </div>
        <div className="padding-spacing"></div>
      </Container>
    </>
  );
}

export { Coaches };
